import { render } from "./App.vue?vue&type=template&id=a1e68e2a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a1e68e2a&lang=css"
script.render = render

export default script